import { createBreakpoints } from "@chakra-ui/theme-tools"

export const breakpoints = createBreakpoints({
  sm: "320px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
})
